/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import Container from "./GlobalComponents/Container";
import Settings from "./Settings";
import Output from "./Output";

const Hero = () => {
  return (
    <section css={styles} className="hero">
      <Container>
        <Settings />
        <Output />
      </Container>
    </section>
  );
};

const styles = css`
  width: 100%;
  min-height: 100vh;
  background: #121418;
  display: flex;
  align-items: center;
  @media (max-width: 980px) {
    .container {
      display: flex;
      flex-direction: column;
    }
  }
  @media (max-width: 1350px) {
    padding: 40px 0 30px 0;
  }
`;

export default Hero;
